import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Conversation } from '../models/conversation';
import { AddContext } from '../../modules/chat/models/add-context';
import { map } from 'rxjs';
import * as moment from 'moment';

import { DictionaryService } from 'src/app/services/dictionary.service';
import { DynamicEntityDataRequest } from 'src/app/models/dynamic-entity-data-request';
import { UserAssistantContext } from 'src/app/modules/assistant/models/user-assistant-context';
import { DynamicEntityRecordCreate } from 'src/app/models/dynamic-entity-record-create';

@Injectable({
  providedIn: 'root'
})
export class ConversationService {

  constructor(private http: HttpClient, private dictionaryService: DictionaryService) { }

  getConversationsByUserId(userId: string) {
    return this.http.get<Conversation[]>(`${environment.urlApi}/chat/conversations/user/${userId}`)
    .pipe(map(
      (conversations: Conversation[]) => conversations.sort((a, b) => {
        return moment(b.updatedTelar).diff(moment(a.updatedTelar));
      })
  ))
  }

  getConversationById(id: string) {
    return this.http.get<Conversation>(`${environment.urlApi}/chat/conversation/${id}`);
  }

  createConversation(conversationDto: Conversation) {
    return this.http.post<Conversation>(`${environment.urlApi}/Chat/conversation`, { conversationDto });
  }

  addMessageToConversation(conversation: Conversation) {
    return this.http.post<Conversation>(`${environment.urlApi}/Chat/conversation/message`, conversation);
  }

  updateConversation(conversation: Conversation) {
    return this.http.put<Conversation>(`${environment.urlApi}/Chat/conversation/title`, conversation);
  }

  deleteConversation(id: string) {
    return this.http.delete(`${environment.urlApi}/Chat/conversation/${id}`);
  }

  addContextToConversation(context: AddContext[]) {
    return this.http.post(`${environment.urlApi}/context`, context);
  }

  getConversationContext(idConversation: string) {
    return this.http.get(`${environment.urlApi}/context/conversation/${idConversation}`);

  }

    getContextMasterById(contextMasterIdTelar: string) {
    const dataRequest: DynamicEntityDataRequest = {
      pageNumber: 1,
      pageSize: 20,
      filters: [
              {
              field: 'idTelar',
              value: contextMasterIdTelar,
            }
      ]
    }
    return this.dictionaryService.getDynamicEntityRecords(dataRequest, environment.cotextMasterEtityId);
    }

    getConversartionsByUserIdAndAssistantId(userId: string, assistantIdTelar: string) {
     
      return this.http.get<Conversation[]>(`${environment.urlApi}/chat/conversations/user/${userId}/assistant?assistantId=${assistantIdTelar}`)
      .pipe(map(
        (conversations: Conversation[]) => conversations.sort((a, b) => {
          return moment(b.updatedTelar).diff(moment(a.updatedTelar));
        })
    ));
  }

//   createUserAssistantContext(context: UserAssistantContext): Promise<UserAssistantContext> {
//     const contextToCreate: DynamicEntityRecordCreate = {
//       fields: {
//         idUser: context.idTelar,
//         idAssistant: context.idTelarContextMaster,

//     return new Promise((resolve, reject) => {
//       this.dictionaryService.createDynamicEntityRecord(contextToCreate, environment.userAssistantContextEntityId)
//         .subscribe({
//           next: (createdContext) => {
//             resolve(createdContext);
//           },
//           error: (err) => {
//             reject(err);
//           }
//         });
//   }
// }

//   getUserAssistantContext(userId: string, assistantIdTelar: string): Promise<UserAssistantContext | null> {
//     return new Promise((resolve, reject) => {

//     const request: DynamicEntityDataRequest = {
//       pageNumber: 1,
//       pageSize: 1,
//       filters: [
//         {
//           field: 'idUser',
//           value: userId
//         },
//         {
//           field: 'idAssistant',
//           value: assistantIdTelar
//         }
//       ]
//     };

//     return this.dictionaryService.getDynamicEntityRecords(request, environment.userAssistantContextEntityId)
//       .subscribe({
//         next: (response) => {
//           if (response && response.records.length > 0) {
//             resolve(response.records[0]);
//           } else {
//             resolve(null);
//           }
//         }
//       });
//     });
//   }

}
